import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { VistoriaApiService } from '../realizar-vistoria/services/vistoria-api.service';
import { VistoriaListItem } from './models/vistoria-list-item';

@Injectable()
export class ListarVistoriasResolver implements Resolve<VistoriaListItem[]> {

  constructor(
    private vistoriaApiService: VistoriaApiService,
  ) { }

  resolve(): Observable<VistoriaListItem[]> {
    return this.vistoriaApiService.listar();
  }
}
